export interface IItemTransfer {
  equipmentKeyId: number;
}
